import { render, staticRenderFns } from "./copyTenantValuesModal.vue?vue&type=template&id=56010a62&scoped=true&"
import script from "./copyTenantValuesModal.vue?vue&type=script&lang=js&"
export * from "./copyTenantValuesModal.vue?vue&type=script&lang=js&"
import style0 from "./copyTenantValuesModal.vue?vue&type=style&index=0&id=56010a62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56010a62",
  null
  
)

export default component.exports